import React from "react";
import { LOGO_DARK, LOGO_LIGHT } from "@/lib/brand";

// variant: "dark" -> black wordmark (light surfaces) | "light" -> white wordmark (dark surfaces)
export const BrandLogo = ({ variant = "dark", className = "h-9", testId = "brand-logo" }) => {
  const src = variant === "light" ? LOGO_LIGHT : LOGO_DARK;
  return (
    <img
      src={src}
      alt="FORMAeSALUTE — Longevity Suite"
      className={`w-auto ${className} select-none`}
      draggable={false}
      data-testid={testId}
    />
  );
};

export default BrandLogo;
